import { CancelButton, EditButton } from '@core/components/Buttons';
import { CustomExpandedPanel } from '@core/components/CustomExpandedPanel';
import { SimpleDialog, SimpleDialogContent } from '@core/components/Dialog';
import { DateLabel, TextLabel } from '@core/components/Inputs';
import { permissaoUtils } from '@core/util/permissaoUtil';
import { formatCNPJ, formatCPF } from '@format';
import { Grid } from '@material-ui/core';
import DadosContatoVisualizar from 'app/main/fornecedor/container/visualizar/DadosContatoVisualizar';
import { ContaBancariaVisualizar } from 'app/main/pessoa/ContaBancaria';
import { EnderecoVisualizar } from 'app/main/pessoa/Endereco';
import { VendedorContext } from 'app/main/vendedor/VendedorContext';
import React, { useContext, useState } from 'react';
import { FaUserTag } from 'react-icons/fa';
import { vendedorModais } from '../vendedorModais';

const TIPO_PESSOAS = {
  FISICA: 'Física',
  JURIDICA: 'Jurídica',
};

const INDICADORES = {
  CONTRIBUINTE: 'Contribuinte de ICMS',
  NAO_CONTRIBUINTE: 'Não contribuinte de ICMS',
  CONTRIBUINTE_ISENTO: 'Contribuinte isento',
};

const formatPercentage = (value) => {
  if (value === null || value === undefined) {
    return '';
  }

  return `${value}`.replace('.', ',');
};

const VisualizarVendedorModal = () => {
  const [modal, setModal] = useContext(VendedorContext).modal;
  const [vendedor] = useContext(VendedorContext).vendedorAtual;

  // FA-08 Fechar
  const handleCloseModal = () => {
    setModal(false);
  };

  const handleOpenEditMode = () => {
    setModal(vendedorModais.cadastroVendedor);
  };

  const DadosVendedorPessoaFisica = ({ values: { pessoaFisica, comissao } }) => {
    return (
      <>
        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
          <TextLabel id="cpf" label="CPF" value={formatCPF(pessoaFisica?.cpf)} />
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
          <TextLabel id="identidade" label="Identidade" value={pessoaFisica?.identidade} />
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
          <DateLabel id="dataNascimento" label="Data do nascimento" value={pessoaFisica?.dataNascimento} />
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
          <TextLabel id="comissao" label="Comissão (%)" value={formatPercentage(comissao)} />
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
          <TextLabel
            id="identificadorEstrangeiro"
            label="Identificador estrangeiro"
            value={pessoaFisica?.identificadorEstrangeiro}
          />
        </Grid>
      </>
    );
  };

  const DadosVendedorPessoaJuridica = ({ values: { pessoaJuridica, comissao } }) => {
    return (
      <>
        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
          <TextLabel id="cnpj" label="CNPJ" value={formatCNPJ(pessoaJuridica?.cnpj)} />
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <TextLabel id="razaoSocial" label="Razão social" value={pessoaJuridica?.razaoSocial} />
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
          <TextLabel id="comissao" label="Comissão (%)" value={formatPercentage(comissao)} />
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
          <DateLabel id="dataFundacao" label="Data da fundação" value={pessoaJuridica?.dataFundacao} />
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
          <TextLabel
            id="indicadorInscricaoEstadual"
            label="Indicador de inscrição estadual"
            value={INDICADORES[pessoaJuridica?.indicadorInscricaoEstadual]}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
          <TextLabel id="inscricaoEstadual" label="Inscrição estadual" value={pessoaJuridica?.inscricaoEstadual} />
        </Grid>
      </>
    );
  };

  const DadosVendedor = () => {
    return (
      <Grid container spacing={3}>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <TextLabel id="nome" label="Nome" value={vendedor?.pessoa?.nome} />
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
          <TextLabel id="tipoPessoa" label="Tipo de pessoa" value={TIPO_PESSOAS[vendedor?.pessoa?.tipoPessoa]} />
        </Grid>
        {vendedor?.pessoa?.tipoPessoa === 'FISICA' ? (
          <DadosVendedorPessoaFisica
            values={{
              pessoaFisica: vendedor?.pessoa?.pessoaFisica,
              comissao: vendedor?.comissao,
            }}
          />
        ) : (
          <DadosVendedorPessoaJuridica
            values={{
              pessoaJuridica: vendedor?.pessoa?.pessoaJuridica,
              comissao: vendedor?.comissao,
            }}
          />
        )}
        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
          <TextLabel id="inscricaoMunicipal" label="Inscrição municipal" value={vendedor?.pessoa?.inscricaoMunicipal} />
        </Grid>
      </Grid>
    );
  };

  const Content = () => {
    const [expanded, setExpanded] = useState('dadosGerais');

    const handleExpandedChange = (key, value) => {
      if (value) {
        setExpanded(key);
      } else {
        setExpanded(false);
      }
    };

    return (
      <div>
        <CustomExpandedPanel
          title="Dados gerais"
          expanded={expanded === 'dadosGerais'}
          defaultExpanded
          onChange={(_, value) => handleExpandedChange('dadosGerais', value)}
        >
          <DadosVendedor />
        </CustomExpandedPanel>
        <CustomExpandedPanel
          title="Endereço"
          expanded={expanded === 'endereco'}
          onChange={(_, value) => handleExpandedChange('endereco', value)}
        >
          <Grid container spacing={3}>
            <EnderecoVisualizar endereco={vendedor?.pessoa?.endereco} />
          </Grid>
        </CustomExpandedPanel>
        <CustomExpandedPanel
          title="Contato"
          expanded={expanded === 'contato'}
          onChange={(_, value) => handleExpandedChange('contato', value)}
        >
          <Grid container spacing={3} style={{ padding: 16 }}>
            <DadosContatoVisualizar registro={vendedor} />
          </Grid>
        </CustomExpandedPanel>
        <CustomExpandedPanel
          title="Conta bancária"
          expanded={expanded === 'contaBancaria'}
          onChange={(_, value) => handleExpandedChange('contaBancaria', value)}
        >
          <Grid container spacing={3}>
            <ContaBancariaVisualizar
              contaBancaria={vendedor?.pessoa?.conta?.contaBancaria}
              contaDescricao={vendedor?.pessoa?.conta?.descricao}
            />
          </Grid>
        </CustomExpandedPanel>
      </div>
    );
  };

  return (
    <SimpleDialog open={modal === vendedorModais.visualizacaoVendedor} onClose={handleCloseModal}>
      <SimpleDialogContent
        header={{
          title: 'Cadastro de vendedor',
          icon: <FaUserTag />,
          toolbar: (
            <>
              <CancelButton onClick={handleCloseModal}>Cancelar</CancelButton>
              {permissaoUtils.vendedor().editar && (
                <EditButton id="add-classe-root" type="submit" onClick={handleOpenEditMode}>
                  Editar
                </EditButton>
              )}
            </>
          ),
        }}
        contentStyle={{ padding: 0 }}
        content={<Content />}
      />
    </SimpleDialog>
  );
};

export default VisualizarVendedorModal;
